<template>
  <div id="app">
    <a-config-provider :locale="zh_CN">
      <router-view v-wechat-title="title" />
    </a-config-provider>
  </div>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
import whiteList from './utils/whiteList'

export default {
  name: 'app',

  computed: {
    title() {
      const { title } = this.$route.meta

      if (title == 'wx') {
        return ''
      } else {
        return `${title} - 授权系统`
      }
    }
  },

  data() {
    return {
      zh_CN
    }
  },

  created() {
    let interval = null
    interval = setInterval(() => {
      if (
        this.$ls.get('token') === null &&
        !whiteList.includes(this.$route.name)
      ) {
        this.$warning({
          title: 'cookie已失效，请重新登录',
          keyboard: false,
          okText: '确定',
          onOk: () => {
            window.location.reload()
          }
        })
        clearInterval(interval)
      }
    }, 1000)
  }
}
</script>


